class WWSimpleCollections extends HTMLElement {
  constructor () {
    super()

    if (window.matchMedia('(max-width: 749px)').matches) {
      setTimeout(() => {
        const left = this.querySelector('.ww-simple-collections-list-item.active')?.getBoundingClientRect().left || 0
        console.log(left)
        this.querySelector('.ww-simple-collections-list').scrollBy({ left, behavior: 'smooth' })
      }, 1000)
    }
  }
}
customElements.define('ww-simple-collections', WWSimpleCollections)